import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const dutyTypeApi = async (dutyType) => {
  let url;
  if (dutyType?.contractId) {
    url = `${env}${API_ENDPOINT.DutyType.api}?contractId=${dutyType?.contractId}`;
  } else {
    url = `${env}${API_ENDPOINT.DutyType.api}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
